module.exports = __webpack_public_path__ + "static/media/corner_bg.67ec4628.svg";